import {
  PostRegistrationPayload,
  PostRegistrationResponse,
} from 'api/typegen/registration/post';
import { useMutation } from '@tanstack/react-query';
import postRegistrationApiCall from 'api/calls/postRegistrationApiCall';

const useCreateRegistrationMutation = () =>
  useMutation<PostRegistrationResponse, unknown, PostRegistrationPayload>(
    (payload: PostRegistrationPayload) => postRegistrationApiCall(payload),
  );

export default useCreateRegistrationMutation;
